import React from 'react'
import CustomModal from 'components/global/CustomModal'
import { manageTeamStore } from 'state/league/manageTeam'
import ManageTeam from './ModalContent/ManageTeam'
import CustomModalFooter from 'components/global/CustomModalFooter'
import GlobalCounterStep from 'components/global/CounterStep'
import ManageDiscount from './ModalContent/ManageDiscount'
import { infoMessage } from 'api/global'

interface ManageteamModalProps {}

const ManageteamModal: React.FC<ManageteamModalProps> = () => {
  const {
    openModal,
    setOpenModal,
    setAddTeamModal,
    setCreateLeagueTeamModal,
    stepCounter,
    setStepCounter,
    leagueTeams,
    setAddDiscountModal,
  } = manageTeamStore(state => ({
    openModal: state.manageTeamModal,
    setOpenModal: state.setManageTeamModal,
    setAddTeamModal: state.setAddTeamModal,
    setCreateLeagueTeamModal: state.setCreateLeagueTeamModal,
    stepCounter: state.stepCounter,
    setStepCounter: state.setStepCounter,
    leagueTeams: state.leagueTeams,
    setAddDiscountModal: state.setAddDiscountModal,
  }))

  const closeModal = () => {
    setStepCounter(0)
    setOpenModal(false)
  }

  const handleAddTeam = () => {
    setAddTeamModal(true)
    setOpenModal(false)
  }

  const handleCreateTeam = () => {
    setCreateLeagueTeamModal(true)
    setOpenModal(false)
  }

  const handleAddDiscount = () => {
    setAddDiscountModal(true)
  }

  const handleNext = () => {
    if (stepCounter === 0) {
      if (leagueTeams.length === 0) {
        return infoMessage('Please add teams')
      } else {
        setStepCounter(stepCounter + 1)
      }
    } else if (stepCounter === 1) {
      closeModal()
    } else {
      infoMessage('Something wrong with manage team counter')
    }
  }

  const steps = [{ title: 'Add Teams' }, { title: 'Discount code' }]

  return (
    <>
      <CustomModal
        openModal={openModal}
        isCloseModalCustom
        closeModal={closeModal}
        title="Manage Teams"
        width={600}
        footer={
          stepCounter === 0 ? (
            <div className="custom-modal-footer px-20px pb-20px">
              <div className="flex justify-between align-center">
                <div className="flex gap-12px">
                  <button
                    className="modal-footer-btn btn-outline"
                    onClick={handleAddTeam}
                  >
                    Add Existing Team
                  </button>
                  <button
                    className="modal-footer-btn btn-outline"
                    onClick={handleCreateTeam}
                  >
                    Create New Team
                  </button>
                </div>
                <button
                  className={`modal-footer-btn ${leagueTeams.length === 0 ? 'secondary' : 'primary'}`}
                  onClick={handleNext}
                >
                  Next
                </button>
              </div>
            </div>
          ) : (
            <CustomModalFooter
              multibutton={true}
              btnAlignment="justify-end"
              btnText="Add discount, Skip"
              btnType="primary"
              isSecondaryOutlined={true}
              closeModal={handleAddDiscount}
              onSubmit={handleNext}
            />
          )
        }
      >
        <>
          <GlobalCounterStep steps={steps} currentStep={stepCounter} />
          {stepCounter === 0 && <ManageTeam />}
          {stepCounter === 1 && <ManageDiscount />}
        </>
      </CustomModal>
    </>
  )
}

export default ManageteamModal
